module.exports = __webpack_public_path__ + "images/emoji/mailbox.12427c6518b5d1eac798.png";